<template>
  <div class="app-container cheliang-page">
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-select v-model="filters.city" filterable clearable placeholder="城市（可搜索）" size="mini" @change="onCityChange">
          <el-option v-for="item in cityOptions" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-select v-model="filters.community_id" filterable clearable placeholder="小区（可搜索）" size="mini">
          <el-option v-for="item in projectSelectOptions" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-input v-model="filters.space_no" size="mini" clearable placeholder="车位编号" />
      </div>
      <div class="shaixuan-item">
        <el-input v-model="filters.phone" size="mini" clearable placeholder="业主/租户手机号" />
      </div>
      <div class="shaixuan-item">
        <el-select v-model="filters.is_rent" clearable placeholder="租车位" size="mini" style="width:110px">
          <el-option label="是" :value="1" />
          <el-option label="否" :value="0" />
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-select v-model="filters.is_parent_child" clearable placeholder="子母车位" size="mini" style="width:110px">
          <el-option label="是" :value="1" />
          <el-option label="否" :value="0" />
        </el-select>
      </div>
      <div class="shaixuan-item expire-range">
        <el-date-picker
          v-model="filters.expire_range"
          type="daterange"
          size="mini"
          range-separator="至"
          start-placeholder="有效期起"
          end-placeholder="有效期止"
          value-format="yyyy-MM-dd"
        />
      </div>
      <div class="shaixuan-item">
        <el-button type="primary" size="mini" class="btn-primary-blue" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="mini" @click="resetFilters">重置</el-button>
        <el-button type="primary" size="mini" class="btn-primary-blue" icon="el-icon-refresh" @click="openSyncDrawer">同步</el-button>
        <el-button size="mini" icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </div>
    </div>

    <div v-loading="listLoading" class="common-section-bg common-section-body table-wrap">
      <el-table :data="displayList" size="mini" style="width: 100%; min-height: 300px">
        <el-table-column prop="city" label="城市" width="70" />
        <el-table-column prop="project" label="小区" width="100" show-overflow-tooltip />
        <el-table-column prop="space_no" label="车位编号" width="100" />
        <el-table-column prop="owner" label="业主" width="80" show-overflow-tooltip />
        <el-table-column label="业主/租户手机号" width="130" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.phone || scope.row.tenant_phone || '—' }}</template>
        </el-table-column>
        <el-table-column prop="fee_amount" label="车位费(元)" width="95" align="right" />
        <el-table-column prop="expire_date" label="车位费有效期" width="115" />
        <el-table-column prop="arrears" label="欠费(元)" width="90" align="right">
          <template slot-scope="scope">
            <span :class="{ 'text-danger': scope.row.arrears !== '0.00' }">{{ scope.row.arrears }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sync_time" label="同步时间" min-width="150" show-overflow-tooltip />
        <el-table-column label="操作" width="190" fixed="right" align="center">
          <template slot-scope="scope">
            <div class="table-action-btns">
              <el-button type="primary" size="mini" class="btn-primary-blue" @click="openBillDrawer(scope.row)">账单详情</el-button>
              <el-button type="primary" size="mini" class="btn-primary-blue" @click="openVehicleDrawer(scope.row)">车辆信息</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="getList"
      />
    </div>

    <el-drawer
      custom-class="custom-drawer"
      :visible.sync="billDrawerVisible"
      :close-on-press-escape="false"
      :wrapper-closable="false"
      :show-close="false"
      size="760px"
    >
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">账单详情</div>
          <i class="el-icon-circle-close close-btn pointer" @click="billDrawerVisible = false" />
        </div>
      </template>
      <div v-if="billRow" v-loading="billLoading || (showBillSync && billSyncing)" class="custom-content vd-panel" :element-loading-text="showBillSync ? '正在从天问同步该车位账单，请稍候…' : '加载中…'">
        <div class="vd-hero">
          <div class="vd-hero-main">
            <div class="vd-hero-title">{{ billRow.space_no || '—' }}</div>
            <div class="vd-hero-sub">{{ billRow.project || '—' }}</div>
          </div>
          <div class="vd-hero-side">
            <div class="vd-hero-meta">
              <span class="vd-hero-label">欠费(元)</span>
              <span class="vd-hero-value">{{ billRow.arrears || '—' }}</span>
            </div>
            <div class="vd-hero-meta">
              <span class="vd-hero-label">车位费有效期</span>
              <span class="vd-hero-value">{{ billRow.expire_date || '—' }}</span>
            </div>
          </div>
        </div>

        <div class="vd-section">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>车位信息</span>
            <div v-if="showBillSync" class="vd-section-actions">
              <el-button
                type="primary"
                size="mini"
                class="btn-primary-blue"
                icon="el-icon-refresh"
                :loading="billSyncing"
                :disabled="!billRow.id"
                @click="syncOneBill"
              >同步账单</el-button>
            </div>
          </div>
          <div class="vd-grid">
            <div class="vd-cell"><span class="vd-lab">小区</span><span class="vd-val">{{ billRow.project || '—' }}</span></div>
            <div class="vd-cell"><span class="vd-lab">车位编号</span><span class="vd-val">{{ billRow.space_no || '—' }}</span></div>
            <div class="vd-cell"><span class="vd-lab">业主</span><span class="vd-val">{{ billRow.owner || '—' }}</span></div>
            <div class="vd-cell"><span class="vd-lab">手机号</span><span class="vd-val">{{ billRow.phone || billRow.tenant_phone || '—' }}</span></div>
            <div class="vd-cell"><span class="vd-lab">车位费有效期</span><span class="vd-val">{{ billRow.expire_date || '—' }}</span></div>
            <div class="vd-cell"><span class="vd-lab">欠费(元)</span><span class="vd-val">{{ billRow.arrears || '—' }}</span></div>
            <div class="vd-cell vd-cell-wide"><span class="vd-lab">同步时间</span><span class="vd-val">{{ billRow.sync_time || '—' }}</span></div>
          </div>
        </div>

        <div class="vd-section vd-section-last">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>账单明细</span>
            <span class="vd-section-count">{{ billList.length }}</span>
          </div>
          <el-table :data="billList" size="mini" class="vd-table" stripe style="width: 100%">
            <el-table-column prop="bill_type_label" label="类型" width="72" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.bill_type === 'settled' ? 'success' : 'danger'" size="mini">{{ scope.row.bill_type_label }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="cost_name" label="费项" width="100" show-overflow-tooltip />
            <el-table-column prop="fee_start_date" label="计费开始" width="100" />
            <el-table-column prop="fee_end_date" label="计费结束" width="100" />
            <el-table-column prop="due_amount" label="应收(元)" width="85" align="right" />
            <el-table-column prop="paid_amount" label="实收(元)" width="85" align="right" />
            <el-table-column prop="debts_amount" label="欠费(元)" width="85" align="right">
              <template slot-scope="scope">
                <span :class="{ 'text-danger': scope.row.debts_amount && scope.row.debts_amount !== '0.00' }">{{ scope.row.debts_amount || '—' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="deal_date" label="收款时间" width="145" show-overflow-tooltip />
            <el-table-column prop="bill_time" label="排序时间" min-width="145" show-overflow-tooltip />
          </el-table>
          <el-empty
            v-if="!billLoading && !(showBillSync && billSyncing) && !billList.length"
            :description="showBillSync ? '暂无账单，可点击上方「同步账单」从天问拉取' : '暂无账单，请先同步车位物业费'"
            :image-size="80"
          />
        </div>
      </div>
    </el-drawer>

    <el-drawer
      custom-class="custom-drawer"
      :visible.sync="vehicleDrawerVisible"
      :close-on-press-escape="false"
      :wrapper-closable="false"
      :show-close="false"
      size="640px"
    >
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">绑定车辆信息</div>
          <i class="el-icon-circle-close close-btn pointer" @click="vehicleDrawerVisible = false" />
        </div>
      </template>
      <div v-if="currentRow" v-loading="detailLoading" class="custom-content vd-panel">
        <div class="vd-hero">
          <div class="vd-hero-main">
            <div class="vd-hero-title">{{ currentRow.space_no || '—' }}</div>
            <div class="vd-hero-sub">{{ currentRow.project || '—' }}</div>
          </div>
          <div class="vd-hero-side">
            <div class="vd-hero-meta">
              <span class="vd-hero-label">业主</span>
              <span class="vd-hero-value">{{ currentRow.owner || '—' }}</span>
            </div>
            <div class="vd-hero-meta">
              <span class="vd-hero-label">车位费有效期</span>
              <span class="vd-hero-value">{{ currentRow.expire_date || '—' }}</span>
            </div>
          </div>
        </div>

        <div class="vd-section">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>车位信息</span>
          </div>
          <div class="vd-grid">
            <div class="vd-cell"><span class="vd-lab">小区</span><span class="vd-val">{{ currentRow.project || '—' }}</span></div>
            <div class="vd-cell"><span class="vd-lab">车位编号</span><span class="vd-val">{{ currentRow.space_no || '—' }}</span></div>
            <div class="vd-cell"><span class="vd-lab">车位费有效期</span><span class="vd-val">{{ currentRow.expire_date || '—' }}</span></div>
            <div class="vd-cell"><span class="vd-lab">业主</span><span class="vd-val">{{ currentRow.owner || '—' }}</span></div>
            <div class="vd-cell vd-cell-wide"><span class="vd-lab">手机号</span><span class="vd-val">{{ currentRow.phone || currentRow.tenant_phone || '—' }}</span></div>
          </div>
        </div>

        <div class="vd-section vd-section-last">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>绑定车辆</span>
            <span class="vd-section-count">{{ (currentRow.vehicles || []).length }}</span>
          </div>
          <el-table :data="currentRow.vehicles || []" size="mini" class="vd-table" stripe style="width: 100%">
            <el-table-column prop="plate" label="车牌号" width="110" />
            <el-table-column prop="owner" label="车主" width="80" show-overflow-tooltip />
            <el-table-column prop="source" label="来源" width="80" />
            <el-table-column prop="vehicle_type" label="类型" width="80" />
            <el-table-column prop="in_garage" label="在库" width="60" align="center" />
            <el-table-column prop="expire_date" label="有效期" min-width="105" />
          </el-table>
          <el-empty v-if="!(currentRow.vehicles || []).length" description="暂无绑定车辆" :image-size="80" />
        </div>
      </div>
    </el-drawer>

    <el-drawer
      custom-class="custom-drawer"
      :visible.sync="syncDrawerVisible"
      :close-on-press-escape="false"
      :wrapper-closable="false"
      :show-close="false"
      size="600px"
      :before-close="handleDrawerClose"
    >
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">车位物业费同步</div>
          <i class="el-icon-circle-close close-btn pointer" @click="closeSyncDrawer" />
        </div>
      </template>
      <div class="custom-content sync-drawer-body vd-panel">
        <div class="vd-section">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>选择小区同步</span>
          </div>
          <div class="sync-action-row">
            <el-select v-model="syncCommunityId" filterable clearable placeholder="请选择小区（可搜索）" size="mini" style="flex:1">
              <el-option v-for="item in communityOptions" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
            <el-button type="primary" size="mini" class="btn-primary-blue" :loading="syncing" :disabled="!syncCommunityId || syncing" @click="startSync">开始同步</el-button>
          </div>
        </div>
        <div class="vd-section">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>同步进度</span>
          </div>
          <div v-if="syncing || syncProgress.total > 0 || syncProgress.message" class="vd-progress-box">
            <div class="progress-text">
              <span>总数：{{ syncProgress.total }}</span>
              <span>已同步：{{ syncProgress.synced }}</span>
              <span>{{ syncProgressPercent }}%</span>
            </div>
            <el-progress :percentage="syncProgressPercent" :status="syncing ? null : 'success'" />
            <p v-if="syncProgress.message" class="progress-phase">{{ syncProgress.message }}</p>
            <p class="progress-tip">{{ syncing ? '同步进行中…' : '同步已完成' }}</p>
            <p v-if="queueWaitHint" class="progress-queue-hint">{{ queueWaitHint }}</p>
          </div>
          <el-empty v-else description="请选择小区并开始同步" :image-size="80" />
        </div>
        <div class="vd-section vd-section-last">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>已同步小区列表</span>
          </div>
          <el-table :data="syncHistory" size="mini" class="vd-table" stripe style="width: 100%" max-height="280">
            <el-table-column prop="project" label="小区" min-width="100" show-overflow-tooltip />
            <el-table-column prop="total" label="总数" width="65" align="center" />
            <el-table-column prop="synced" label="已同步" width="70" align="center" />
            <el-table-column prop="start_time" label="开始时间" width="145" show-overflow-tooltip />
            <el-table-column prop="end_time" label="结束时间" width="145" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.end_time || '—' }}</template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="75" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === '已完成' ? 'success' : (scope.row.status === '失败' ? 'danger' : 'warning')" size="mini">{{ scope.row.status }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="message" label="阶段说明" min-width="160" show-overflow-tooltip />
          </el-table>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import chechangParkingSpace from '@/api/tianzheng/chechangParkingSpace'
import chechangParkingFee from '@/api/tianzheng/chechangParkingFee'

const defaultFilters = () => ({
  city: '',
  community_id: '',
  space_no: '',
  phone: '',
  is_rent: '',
  is_parent_child: '',
  expire_range: null
})

export default {
  name: 'ParkingFeeSync',
  components: { Pagination },
  data() {
    return {
      listLoading: false,
      detailLoading: false,
      billLoading: false,
      billSyncing: false,
      // false=隐藏账单详情「同步账单」按钮；改为 true 即可恢复入口（方法/接口仍保留）
      showBillSync: false,
      exportLoading: false,
      communityOptions: [],
      cityOptions: [],
      displayList: [],
      total: 0,
      listQuery: { page: 1, size: 10 },
      filters: defaultFilters(),
      vehicleDrawerVisible: false,
      billDrawerVisible: false,
      syncDrawerVisible: false,
      currentRow: null,
      billRow: null,
      billList: [],
      syncCommunityId: '',
      syncing: false,
      syncProgress: { total: 0, synced: 0, message: '' },
      syncHistory: [],
      syncTimer: null,
      currentTaskId: null,
      syncStartedAt: null
    }
  },
  computed: {
    projectSelectOptions() {
      if (!this.filters.city) return this.communityOptions
      return this.communityOptions.filter(item => item.city === this.filters.city)
    },
    syncProgressPercent() {
      if (!this.syncProgress.total) return 0
      return Math.min(100, Math.round((this.syncProgress.synced / this.syncProgress.total) * 100))
    },
    queueWaitHint() {
      if (!this.syncing || !this.syncProgress.message) return ''
      if (this.syncProgress.message.indexOf('等待队列') === -1) return ''
      if (!this.syncStartedAt) return ''
      if (Date.now() - this.syncStartedAt < 15000) return ''
      return '任务长时间未开始，请确认队列 worker 已启动：php artisan queue:work'
    }
  },
  created() {
    this.loadCommunityOptions()
    this.getList()
  },
  beforeDestroy() {
    this.clearSyncTimer()
  },
  methods: {
    loadCommunityOptions() {
      chechangParkingSpace.communitySelect().then(res => {
        if (res.code === 200) {
          this.communityOptions = res.result || []
          this.cityOptions = [...new Set(this.communityOptions.map(i => i.city).filter(Boolean))]
        }
      })
    },
    buildListParams() {
      const params = {
        page: this.listQuery.page,
        size: this.listQuery.size,
        city: this.filters.city,
        community_id: this.filters.community_id,
        space_no: this.filters.space_no,
        phone: this.filters.phone,
        is_rent: this.filters.is_rent,
        is_parent_child: this.filters.is_parent_child
      }
      if (this.filters.expire_range && this.filters.expire_range.length === 2) {
        params.expire_start = this.filters.expire_range[0]
        params.expire_end = this.filters.expire_range[1]
      }
      return params
    },
    getList() {
      this.listLoading = true
      chechangParkingFee.list(this.buildListParams()).then(res => {
        this.listLoading = false
        if (res.code === 200) {
          this.displayList = res.result.list || []
          this.total = res.result.total || 0
        }
      }).catch(() => { this.listLoading = false })
    },
    handleSearch() {
      this.listQuery.page = 1
      this.getList()
    },
    onCityChange() {
      if (this.filters.community_id) {
        const found = this.projectSelectOptions.find(i => i.id === this.filters.community_id)
        if (!found) this.filters.community_id = ''
      }
    },
    resetFilters() {
      this.filters = defaultFilters()
      this.listQuery.page = 1
      this.getList()
    },
    openBillDrawer(row) {
      this.billDrawerVisible = true
      this.billLoading = true
      this.billRow = { ...row }
      this.billList = []
      chechangParkingFee.bills({ id: row.id }).then(res => {
        this.billLoading = false
        if (res.code === 200) {
          this.billRow = { ...row, ...res.result }
          this.billList = res.result.bills || []
        }
      }).catch(() => { this.billLoading = false })
    },
    syncOneBill() {
      if (!this.billRow || !this.billRow.id || this.billSyncing) return
      this.billSyncing = true
      chechangParkingFee.syncOne({ id: this.billRow.id }).then(res => {
        this.billSyncing = false
        if (res.code === 200) {
          const data = res.result || {}
          if (data.fee) {
            this.billRow = { ...this.billRow, ...data.fee }
            this.patchListRow(data.fee)
          }
          this.billList = data.bills || []
          this.$message.success(
            `同步成功：未结清 ${data.unpaid_count || 0} 条，已结清 ${data.settled_count || 0} 条`
          )
        } else {
          this.$message.error(res.msg || '同步失败')
        }
      }).catch(err => {
        this.billSyncing = false
        this.$message.error((err && err.message) || '同步失败')
      })
    },
    patchListRow(fee) {
      if (!fee || !fee.id) return
      const idx = this.displayList.findIndex(item => item.id === fee.id)
      if (idx < 0) return
      this.$set(this.displayList, idx, { ...this.displayList[idx], ...fee })
    },
    openVehicleDrawer(row) {
      this.vehicleDrawerVisible = true
      this.detailLoading = true
      this.currentRow = { ...row }
      chechangParkingFee.detail({ id: row.id }).then(res => {
        this.detailLoading = false
        if (res.code === 200) {
          this.currentRow = res.result
        }
      }).catch(() => { this.detailLoading = false })
    },
    openSyncDrawer() {
      this.syncDrawerVisible = true
      this.loadSyncHistory()
    },
    loadSyncHistory() {
      chechangParkingFee.syncHistory({ page: 1, size: 20 }).then(res => {
        if (res.code === 200) {
          this.syncHistory = res.result.list || []
        }
      })
    },
    closeSyncDrawer() {
      if (this.syncing) {
        this.handleDrawerClose(() => { this.syncDrawerVisible = false })
        return
      }
      this.syncDrawerVisible = false
    },
    handleDrawerClose(done) {
      if (this.syncing) {
        this.$confirm('同步进行中，确定关闭？', '提示', { type: 'warning' })
          .then(() => {
            this.clearSyncTimer()
            this.syncing = false
            done()
          })
          .catch(() => {})
        return
      }
      done()
    },
    startSync() {
      if (!this.syncCommunityId) {
        this.$message.warning('请选择小区')
        return
      }
      this.clearSyncTimer()
      this.syncing = true
      this.syncStartedAt = Date.now()
      this.syncProgress = { total: 0, synced: 0, message: '任务已提交…' }
      chechangParkingFee.sync({ community_id: this.syncCommunityId }).then(res => {
        if (res.code !== 200) {
          this.syncing = false
          this.$message.error(res.message || '同步失败')
          return
        }
        this.currentTaskId = res.result.task_id
        this.pollSyncProgress()
        this.syncTimer = setInterval(() => { this.pollSyncProgress() }, 1500)
      }).catch(() => { this.syncing = false })
    },
    pollSyncProgress() {
      if (!this.currentTaskId) return
      chechangParkingFee.syncProgress({ task_id: this.currentTaskId }).then(res => {
        if (res.code !== 200) return
        const data = res.result
        this.syncProgress = {
          total: data.total,
          synced: data.synced,
          message: data.message || ''
        }
        if (data.status === 'completed' || data.status === 'failed') {
          this.finishSync(data.status === 'failed', data.message)
        }
      })
    },
    finishSync(failed, message) {
      this.clearSyncTimer()
      this.syncing = false
      this.loadSyncHistory()
      this.getList()
      if (failed) {
        this.$message.error(message || '同步失败，请查看同步历史')
      } else {
        this.$message.success('车位物业费同步完成')
      }
    },
    clearSyncTimer() {
      if (this.syncTimer) {
        clearInterval(this.syncTimer)
        this.syncTimer = null
      }
    },
    handleExport() {
      this.exportLoading = true
      chechangParkingFee.export(this.buildListParams()).then(res => {
        this.exportLoading = false
        if (res.code === 200 && res.result.url) {
          window.open(res.result.url, '_blank')
          this.$message.success('导出成功')
        }
      }).catch(() => { this.exportLoading = false })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/page.scss';
.text-danger { color: #f56c6c; }
.bill-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.progress-phase {
  margin: 8px 0 4px;
  font-size: 12px;
  color: #409eff;
  line-height: 1.5;
  word-break: break-all;
}
.progress-queue-hint {
  margin: 4px 0 0;
  font-size: 12px;
  color: #e6a23c;
}
</style>

<style lang="scss">
@import '../styles/drawer-patch.scss';
</style>
